var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotelsReviewsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.hotels{fill:url(#hotels-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotels-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3f1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34474,
    stopColor: "#f6a0d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48367,
    stopColor: "#fe7fca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc35cd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hotels",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M62.18988,25.52655h-24.37976c-1.49939,0-2.71484,1.21552-2.71484,2.7149v43.37189c0,1.49939,1.21545,2.71497,2.71484,2.71497h7.96289v-10.94568c0-.367.29755-.66455.66455-.66455h7.12488c.367,0,.66455.29755.66455.66455v10.94568h7.96289c1.49939,0,2.71484-1.21558,2.71484-2.71497V28.24146c0-1.49939-1.21545-2.7149-2.71484-2.7149ZM47.90961,56.77283h-6.24994v-6.25h6.24994v6.25ZM46.87451,43.32941c-.6828.31415-1.44617-.24054-1.35846-.987l.40137-3.41663-2.33301-2.52826c-.5097-.55243-.21808-1.44971.51892-1.59698l3.37347-.67413,1.68359-3.00012c.3678-.6554,1.31128-.6554,1.6792,0l1.68359,3.00012,3.37347.67413c.737.14728,1.02863,1.04456.51892,1.59698l-2.33301,2.52826.40131,3.41663c.08765.74646-.6756,1.30115-1.3584.987l-3.12555-1.4375-3.12543,1.4375ZM58.34033,56.77283h-6.24994v-6.25h6.24994v6.25Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelsReviewsScraper);
export default __webpack_public_path__ + "static/media/hotels-reviews-scraper.a4429f0bdc27baca465d29e98c77e2eb.svg";
export { ForwardRef as ReactComponent };